var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCreditcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M38.4589882,38H11.5400419c-2.2275391,0-4.0400391-1.8613281-4.0400391-4.1484375v-17.703125 C7.5000029,13.8608398,9.3125029,12,11.5400419,12h26.9189453c2.2285156,0,4.0410156,1.8608398,4.0410156,4.1484375v17.703125 C42.5000038,36.1386719,40.6875038,38,38.4589882,38z M11.5400419,14c-1.125,0-2.0400391,0.9638672-2.0400391,2.1484375v17.703125 C9.5000029,35.0361328,10.4150419,36,11.5400419,36h26.9189453c1.125,0,2.0410156-0.9638672,2.0410156-2.1484375v-17.703125 C40.5000038,14.9638672,39.5839882,14,38.4589882,14H11.5400419z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M41.5000038,22.5h-33c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h33c0.5527344,0,1,0.4477539,1,1 S42.0527382,22.5,41.5000038,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M17.23633,33h-3.4726553c-1.2480469,0-2.2636719-1.015625-2.2636719-2.2636719v-3.4736328 C11.5000029,26.0146484,12.5156279,25,13.7636747,25H17.23633c1.2480469,0,2.2636719,1.0146484,2.2636719,2.2626953v3.4736328 C19.5000019,31.984375,18.4843769,33,17.23633,33z M13.7636747,27c-0.1455078,0-0.2636719,0.1181641-0.2636719,0.2626953v3.4736328 C13.5000029,30.8818359,13.6181669,31,13.7636747,31H17.23633c0.1455078,0,0.2636719-0.1181641,0.2636719-0.2636719v-3.4736328 C17.5000019,27.1181641,17.3818378,27,17.23633,27H13.7636747z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditcard);
export default __webpack_public_path__ + "static/media/icon_creditcard.295e7fc2930bb07c1f23d22fb04cf94f.svg";
export { ForwardRef as ReactComponent };